import moment from 'moment-timezone'
import _ from 'underscore'
import Vue from 'vue'

export default {
  namespaced: true,
  state () {
    return {
      info: {
        id: null,
        contact_type: 0,
        customer: null,
        customer_input: null,
        customer_pic: null,
        contact_products: [
          {
            id: null,
            item: null,
            item_input: null,
            country: null,
            country_input: null,
            size: null,
            size_input: null,
            supplier: null,
            supplier_input: null,
            variety: null,
            variety_input: null,
            note: null,
            removed: false
          },
          {
            id: null,
            item: null,
            item_input: null,
            country: null,
            country_input: null,
            size: null,
            size_input: null,
            supplier: null,
            supplier_input: null,
            variety: null,
            variety_input: null,
            note: null,
            removed: false
          }
        ],
        auction_date: null,
        contact_date: moment().format('YYYY-MM-DD'),
        contact_time: moment().format('HH:mm'),
        contact_files: [],
        member: null,
        reminder_date: null,
        reminder_time: null,
        memo: null
      },
      action: {
        is_order_finished: null,
        chart_detail_ids: [],
        order_memo: null,
        zaikos: []
      },
      customers: [],
      members: [],
      items: [],
      varieties: [],
      sizes: [],
      typeContact: [],
      statuses: [],
      boxTypes: [],
      units: [],
      genuses: [],
      suppliers: [],
      countries: [],
      allocated_chart_detail: []
    }
  },
  getters: {
    getContactProducts (state) {
      return state.info.contact_products.filter(product => product.removed !== true)
    },
    info (state) {
      return state.info
    },
    getImgInfo (state) {
      return state.info.contact_files.filter(img => img.id && img.removed === false)
    },
    action (state) {
      return state.action
    },
    customers (state) {
      return state.customers
    },
    members (state) {
      return state.members
    },
    items (state) {
      return state.items
    },
    varieties (state) {
      return state.varieties
    },
    sizes (state) {
      return state.sizes
    },
    typeContact (state) {
      return state.typeContact
    },
    statuses (state) {
      return state.statuses
    },
    boxTypes (state) {
      return state.boxTypes
    },
    units (state) {
      return state.units
    },
    genuses (state) {
      return state.genuses
    },
    suppliers (state) {
      return state.suppliers
    },
    countries (state) {
      return state.countries
    },
    allocatedChartDetail (state) {
      return state.allocated_chart_detail
    }
  },
  mutations: {
    addContactProduct (state) {
      state.info.contact_products.push({
        id: null,
        item: null,
        item_input: null,
        country: null,
        country_input: null,
        size: null,
        size_input: null,
        supplier: null,
        supplier_input: null,
        variety: null,
        variety_input: null,
        note: null,
        removed: false
      })
    },
    addContactFiles (state, payload) {
      state.info['contact_files'].push(payload)
    },
    removePendingUploadContactFiles (state, index) {
      state.info['contact_files'].splice(index, 1)
    },
    removeContactFiles (state, index) {
      state.info['contact_files'][index].removed = true
    },
    removeContactProduct (state, index) {
      Vue.set(state.info['contact_products'][index], 'removed', true)
    },
    updateInfo (state, info) {
      Object.assign(state.info, info)
    },
    updateContactProducts (state, payload) {
      const target = payload.target
      const params = _.omit(payload, 'target')
      Object.assign(target, params)
    },
    updateAction (state, action) {
      Object.assign(state.action, action)
    },
    updateState (state, payload) {
      state[payload.key] = payload.value
    },
    setCustomers (state, customers) {
      state.customers = customers
    },
    setMembers (state, members) {
      state.members = members
    },
    setItems (state, items) {
      state.items = items
    },
    setVarieties (state, varieties) {
      state.varieties = varieties
    },
    setSizes (state, sizes) {
      state.sizes = sizes
    },
    setTypeContact (state, typeContact) {
      state.typeContact = typeContact
    },
    setStatuses (state, statuses) {
      state.statuses = statuses
    },
    setBoxTypes (state, boxTypes) {
      state.boxTypes = boxTypes
    },
    setUnits (state, units) {
      state.units = units
    },
    setGenuses (state, genuses) {
      state.genuses = genuses
    },
    setSuppliers (state, suppliers) {
      state.suppliers = suppliers
    },
    setCountries (state, countries) {
      state.countries = countries
    },
    setAllocatedChartDetail (state, allocatedChartDetail) {
      state.allocated_chart_detail = allocatedChartDetail
    },
    resetAll (state) {
      state.info = {
        id: null,
        contact_type: 0,
        customer: null,
        customer_input: null,
        customer_pic: null,
        contact_products: [
          {
            item: null,
            item_input: null,
            country: null,
            country_input: null,
            size: null,
            size_input: null,
            supplier: null,
            supplier_input: null,
            variety: null,
            variety_input: null,
            note: null
          },
          {
            item: null,
            item_input: null,
            country: null,
            country_input: null,
            size: null,
            size_input: null,
            supplier: null,
            supplier_input: null,
            variety: null,
            variety_input: null,
            note: null
          }
        ],
        auction_date: null,
        contact_files: [],
        contact_date: moment().format('YYYY-MM-DD'),
        contact_time: moment().format('HH:mm'),
        member: null,
        reminder_date: null,
        reminder_time: null,
        memo: null,
        allocated_chart_detail: null
      }
      state.action = {
        is_order_finished: null,
        chart_detail_ids: [],
        order_memo: null,
        zaikos: []
      }
      state.allocated_chart_detail = []
    },
    addChartDetail (state, ids) {
      state.action.chart_detail_ids = state.action.chart_detail_ids.concat(ids)
    },
    addItemToArrayState (state, payload) {
      state[payload.key] = [...state[payload.key], payload.value]
    }
  },
  actions: {
    updateInfo ({commit}, info) {
      commit('updateInfo', info)
    },
    updateAction ({commit}, action) {
      commit('updateAction', action)
    },
    setCustomers ({commit}, customers) {
      commit('setCustomers', customers)
    },
    setMembers ({commit}, members) {
      commit('setMembers', members)
    },
    setItems ({commit}, items) {
      commit('setItems', items)
    },
    setVarieties ({commit}, varieties) {
      commit('setVarieties', varieties)
    },
    setSizes ({commit}, sizes) {
      commit('setSizes', sizes)
    },
    setTypeContact ({commit}, typeContact) {
      commit('setTypeContact', typeContact)
    },
    setStatuses ({commit}, statuses) {
      commit('setStatuses', statuses)
    },
    setBoxTypes ({commit}, boxTypes) {
      commit('setBoxTypes', boxTypes)
    },
    setUnits ({commit}, units) {
      commit('setUnits', units)
    },
    setGenuses ({commit}, genuses) {
      commit('setGenuses', genuses)
    },
    setSuppliers ({commit}, suppliers) {
      commit('setSuppliers', suppliers)
    },
    setCountries ({commit}, countries) {
      commit('setCountries', countries)
    },
    setAllocatedChartDetail ({commit}, allocatedChartDetail) {
      commit('setAllocatedChartDetail', allocatedChartDetail)
    },
    addChartDetail ({commit}, ids) {
      commit('addChartDetail', ids)
    },
    emptyContactStore ({commit}) {
      commit('resetAll', null)
      // commit('updateState', null)
      commit('setCustomers', [])
      commit('setMembers', [])
      commit('setItems', [])
      commit('setVarieties', [])
      commit('setSizes', [])
      commit('setTypeContact', [])
      commit('setStatuses', [])
      commit('setBoxTypes', [])
      commit('setUnits', [])
      commit('setGenuses', [])
      commit('setSuppliers', [])
      commit('setCountries', [])
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Contact/store.js